import { useState } from "react";
import FeatureItem from "../../pricing/components/FeatureItem";
import {
  INSTA_TOOL_FEATURES_INITIAL_VISIBLE,
} from "../data/instaToolPricing.config";

const InstaToolFeatureList = ({ features, theme = "light" }) => {
  const [expanded, setExpanded] = useState(false);

  const hasMore = features.length > INSTA_TOOL_FEATURES_INITIAL_VISIBLE;
  const visibleFeatures = expanded
    ? features
    : features.slice(0, INSTA_TOOL_FEATURES_INITIAL_VISIBLE);

  return (
    <div className="mt-6 space-y-3 text-left">
      {visibleFeatures.map((feature, index) => (
        <FeatureItem key={`${feature.label}-${index}`} {...feature} />
      ))}

      {hasMore && (
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className={`text-sm font-medium mt-1 underline focus:outline-none ${
            theme === "dark"
              ? "text-white/80 hover:text-white"
              : "text-black/70 hover:text-black"
          }`}
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};

export default InstaToolFeatureList;
